import { useState } from 'react'
import { TurboPickupPinIcon } from 'src/components/Icons/TurboPickupPinIcon'

type TurboPickupZipInputProps = {
  onSearch: (zipCode: string) => void | Promise<void>
  isLoading?: boolean
  onSearchButtonClick?: () => void
  onValidationError?: () => void
}

export function TurboPickupZipInput({
  onSearch,
  isLoading = false,
  onSearchButtonClick,
  onValidationError,
}: TurboPickupZipInputProps) {
  const [value, setValue] = useState('')
  const [error, setError] = useState('')

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let raw = e.target.value.replace(/\D/g, '')

    if (raw.length > 8) raw = raw.slice(0, 8)

    const masked = raw.length > 5 ? `${raw.slice(0, 5)}-${raw.slice(5)}` : raw

    setValue(masked)
    setError('')
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    const digits = value.replace(/\D/g, '')

    if (digits.length < 8) {
      setError('CEP inválido. Por favor, confira o número informado.')
      onValidationError?.()

      return
    }

    onSearch(digits)
  }

  return (
    <form className="flex flex-col gap-3" onSubmit={handleSubmit}>
      <label
        htmlFor="turbo-pickup-zip"
        className="text-[13px] font-semibold text-[#364153]"
      >
        Digite seu CEP
      </label>

      <div className="flex flex-col gap-2 restructure-small-desktop:grid restructure-small-desktop:grid-cols-[1fr_auto] restructure-small-desktop:items-stretch restructure-small-desktop:gap-3">
        <div className="relative flex-1">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">
            <TurboPickupPinIcon
              className="text-turboPickupBody"
              aria-hidden="true"
            />
          </span>
          <input
            id="turbo-pickup-zip"
            data-testid="turbo-pickup-zip-input"
            type="text"
            value={value}
            onChange={handleInputChange}
            placeholder="00000-000"
            maxLength={9}
            className="w-full h-[47px] pl-9 pr-3 border border-[#d1d5dc] text-base text-turboPickupTitle placeholder-turboPickupMuted focus:outline-none focus:border-turboPickupAction disabled:opacity-50"
            disabled={isLoading}
          />
        </div>

        <button
          data-testid="turbo-pickup-search-button"
          type="submit"
          onClick={onSearchButtonClick}
          disabled={isLoading}
          className="w-full h-[47px] px-5 bg-turboPickupAction text-white text-[14px] font-bold whitespace-nowrap disabled:opacity-50 hover:bg-turboPickupActionHover transition-colors restructure-small-desktop:w-auto"
        >
          {isLoading ? 'Buscando...' : 'Buscar lojas'}
        </button>
      </div>

      {error && <span className="text-xs text-redDiscount">{error}</span>}
    </form>
  )
}
